<script setup lang="ts">
import { maskito as vMaskito } from '@maskito/vue'
import { MtdButton, MtdField, MtdTypography } from '@paygine/mtd-uikit'

import type { Steps } from '@/shared/constants'

import { userDataModel } from '@/entities/user-data'
import { useModel } from '@/pages/tollroads_enroll_page/model'
import { useConfig } from '@/shared/config'
import { phoneMaskOptions } from '@/shared/lib/masks'

const {
    config: { agreementUrl, conditionUrl, policyUrl },
} = useConfig()

const { isLoading, sendOtp } = useModel()

const { r$ } = userDataModel.useModel()

const emit = defineEmits<{
    goto: [Steps]
}>()

async function submitHandler() {
    const { valid } = await r$.$validate()

    if (!valid) {
        return
    }

    if (await sendOtp()) {
        emit('goto', 'verify')
    }
}
</script>

<template>
    <MtdTypography
        variant="header-2"
        class="default-layout__title"
        tag="h1"
        >Введите номер телефона
    </MtdTypography>

    <MtdTypography
        tag="p"
        variant="body-2"
        class="default-layout__subtitle"
        >ⓘ Этот номер должен совпадать с номером в вашем профиле в приложении Совкомбанк. Мы
        отправим на него код подтверждения</MtdTypography
    >

    <form
        action=""
        class="auth-form"
        @submit.prevent="submitHandler"
    >
        <MtdField
            v-model="r$.phone.$value"
            v-maskito="phoneMaskOptions"
            :has-error="r$.phone.$error"
            :message="r$.phone.$errors[0]"
            inputmode="numeric"
            class="auth-form__phone"
            label="Номер телефона"
            @blur="r$.phone.$touch()"
        />

        <MtdButton
            class="auth-form__button"
            :is-loading="isLoading"
            >Отправить код</MtdButton
        >

        <MtdTypography
            tag="p"
            variant="body-3"
            class="auth-form__condition"
        >
            <a
                :href="conditionUrl"
                rel="noopener noreferrer"
                target="_blank"
                >Условия начисления кэшбэка</a
            >
        </MtdTypography>

        <MtdTypography
            tag="p"
            variant="body-3"
            class="auth-form__condition"
        >
            Нажимая на кнопку, вы даете
            <a
                :href="agreementUrl"
                target="_blank"
                rel="noopener noreferrer"
                >согласие</a
            >
            <br />
            на обработку персональных данных <br />
            в соответствии с
            <a
                :href="policyUrl"
                target="_blank"
                rel="noopener noreferrer"
                >политикой обработки
            </a>
        </MtdTypography>
    </form>
</template>

<style lang="scss" src="./VAuthorization.scss"></style>
